import type {
  IGoodsListPageInitialData,
  IProductListApiResponse,
  IProductListItem,
} from '@/api/types/product';
import { createGoodsListClientGroup } from '../components/goodsListSeoFooter.utils';

/** 仅裁剪列表项根级分组；保留关联商品和广告跳转配置中的同名字段。 */
export function toGoodsListItemsDto<T extends IProductListItem & { product_group?: unknown }>(
  list: T[],
): Omit<T, 'product_group'>[] {
  return list.map(({ product_group: _productGroup, ...item }) => item);
}

/** 响应 params（含 order_custom_sort）不进入页面的 Server → Client 边界。 */
export function toGoodsListInitialData(
  data: IProductListApiResponse,
  page: number,
  limit: number,
): IGoodsListPageInitialData {
  const { group, list, total, all_total, image_rule, hover_image_rule } = data;

  return {
    group: createGoodsListClientGroup(group),
    list: toGoodsListItemsDto(list),
    total,
    all_total,
    image_rule,
    hover_image_rule,
    noData: list.length === 0,
    noMoreShow: all_total <= page * limit,
  };
}
